import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { addExtras } from 'apps/auth/actions/extraAction';
import { setNewFields } from 'apps/auth/actions/formAction';
import { CountryItemPanel } from 'apps/auth/components/common/components/CountryItemPanel/CountryItemPanel';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { ComplexPopupRow } from 'apps/auth/components/common/Popup/styles';
import { AUTH_REQUEST_CREATE } from 'apps/auth/constants/UrlConstants';
import { changeBrowserUrlWithOutReload } from 'apps/auth/helpers/api';
import { currencyPropType } from 'apps/auth/helpers/customPropTypes';
import { toLowerCase, toUpperCase } from 'apps/auth/helpers/utils';
import { ApiService } from 'apps/auth/services/apiService';

const CalculatorCurrenciesPopup = ({ isGlobalFlow = false, popupRef = null, ...props }) => {
    const getFetchCurrencyUrl = (currencyCode, currencyId) => {
        let path = `${toLowerCase(props.countryCode)}/${toLowerCase(currencyCode)}/${props.deliveryMethod}?keepAmount=true`;

        if (props.typeOfTransfer) {
            path += `&type=${props.typeOfTransfer}`;
        }

        if (props.isBonus) {
            return `${props.fetchCurrencyUrl}/profile/bonus/withdraw/${path}`;
        } else if (props.isRequest) {
            return `${AUTH_REQUEST_CREATE}/${currencyId}/${props.fromCountryCode}`;
        }

        return `${props.fetchCurrencyUrl}/send/${path}`;
    };

    const click = (e, currency) => {
        e.preventDefault();
        if (currency.id !== props.current) {
            const url = getFetchCurrencyUrl(currency.code, currency.id);
            ApiService.fetch(
                url,
                props,
                (json) => {
                    if (!props.isRequest && !isGlobalFlow) {
                        changeBrowserUrlWithOutReload(url, json);
                    }
                    if (json) {
                        const extra = json?.extra;
                        if (extra) {
                            props.addExtras(extra);
                        }

                        const fields = json?.forms[props.formName]?.fields;
                        if (fields) {
                            props.setNewFields(props.formName, fields);
                        }
                    }
                },
                null,
                popupRef,
            );
        }
        popupRef.current?.close();
    };

    return (
        <ComplexPopup withoutButton textCenter={props.textCenter} popupRef={popupRef}>
            <>
                {props.title && (
                    <>
                        <ComplexPopupRow>{props.title}</ComplexPopupRow>
                        <Separator />
                    </>
                )}
                {props.currencies.map((currency) => (
                    <CountryItemPanel
                        key={`selectCurrency_${currency.code}`}
                        to={getFetchCurrencyUrl(currency.code)}
                        onClick={(e) => click(e, currency)}
                        flagIconName={toLowerCase(currency.code)}
                        countryName={currency.name}
                        countryCurrency={toUpperCase(currency.code)}
                        isSelectedCountry={props.current === currency.id}
                        getCurrencyIcon={props.getCurrencyIcon}
                        onError={props.onIconRenderError}
                    />
                ))}
            </>
        </ComplexPopup>
    );
};

CalculatorCurrenciesPopup.propsType = {
    formName: PropTypes.string.isRequired,
    currencies: PropTypes.arrayOf(currencyPropType).isRequired,
    fetchCurrencyUrl: PropTypes.string,
    isBonus: PropTypes.bool,
    isRequest: PropTypes.bool,
    isGlobalFlow: PropTypes.bool,
    current: PropTypes.number,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    getCurrencyIcon: PropTypes.func,
    onError: PropTypes.func,
};
const mapStateToProps = (state, ownProps) => {
    return {
        fields: state.form[ownProps.formName].fields,
        deliveryMethod: state.extra.deliveryMethod,
        pocketId: state.extra.pocket?.id,
        toCountryCode: state.extra.toCountry?.code,
        countryCode: state.extra.toCountry?.code,
        fetchCurrencyUrl: ownProps.fetchCurrencyUrl,
    };
};
export default connect(mapStateToProps, {
    addExtras,
    setNewFields,
    toggleSpinner,
})(CalculatorCurrenciesPopup);
